import React, { forwardRef, useState, useImperativeHandle, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Loading } from '../../Utilities/Loading'
import { useTranslation } from 'react-i18next';
import { APIPost } from '../../API/APIRequest';
import { GetBasket } from './Basket';
import '../../../i18n';
import useBodyClass from  '../../../Hooks/useBodyClass';
import usePageTitle from '../../../Hooks/usePageTitle';
import { appendClientQueryParams } from '../../Utilities/Functions';
export function WorldpayResponseHandler(props) {
    
    const [errors, setErrors] = useState([]);
    const { t, i18n } = useTranslation();
    const { fid } = useParams();
    const { status } = useParams();
    const [currentAction, setCurrentAction] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isProcessing, setIsProcessing] = useState(false);
    useBodyClass(['payment-process']);
    usePageTitle(`Payment Processing with Worldpay -  ${props.brandingElement?.id}`);
    var params = (new URL(document.location)).searchParams;
    const hasConfirmedPaymentRef = useRef(false);
 

    const confirmPayment = () => {
        GetBasket({ "fid": fid, "loadfromserver": false }).then((basket) => {
            if (basket.offertypename !== "paid free trial") {
                APIPost({
                    "controller": "worldpay",
                    "action": "processpayment",
                    "environment": null,
                    "identifier": fid
                }).then((response) => {

                    let url=window.location.protocol + "//" + window.location.host + "/thankyou/" + response.data.OrderId ;
                    let updatedUrl= appendClientQueryParams(url);
                    window.location.href = updatedUrl;
                }).catch((error) => {
                      
                    console.log("Error occured while processing payement")

                });
            }
            else {
                APIPost({
                    "controller": "freetrial",
                    "action": "completetokenisedfreetrialsetup",
                    "environment": null,
                    "data": {
                        "fid": fid
                    }
                }).then((response) => {

                    let url=window.location.protocol + "//" + window.location.host + "/thankyou/" + response.data.OrderId ;
                    let updatedUrl= appendClientQueryParams(url);
                    window.location.href = updatedUrl;
                   
                }).catch((error) => {
                     
                    console.log("Error occured while processing payement")

                });
            }
        }).catch((error) => {
         
            console.log("Error occured while fetching basket data")
        });
       
    }
    
    useEffect(()=>{
        
        if(!fid || hasConfirmedPaymentRef.current){
            return;
        }
        
        hasConfirmedPaymentRef.current=true;
        confirmPayment();   // Needs to run just once, made a change to how it was being called. (wrapped it in a useEffect).

    }, [fid])
      

    return (
                <div className="container" aria-live="polite">
                        <div className="item-container">
                            <div className="item-wrapper">
                    <h1 className="module-heading" tabIndex="-1" >{t('worldpayHandling.title')} </h1>
                            </div>
                        </div> 
                        <div className="item-container">
                            <div className="item-wrapper">
                            <p>{t('worldpayHandling.message')} </p>
                            </div>
                        </div> 
                        <div className="item-container">
                            <div className="item-wrapper">
                            <Loading loading={loading} />
                            </div>
                        </div>
                </div> 
             
    )
}

